import { addMonths, getDate, getDaysInMonth, parseISO, startOfMonth } from "date-fns";
import Session from "@lib/session";

/**
 * Returns the date the return calendar should open to.
 * - Only applies to the second leg (return trip)
 * - Only when no return date is selected yet
 * - Shows next month if pickup is in last 2 days of the month
 */
export function getReturnCalendarOpenDate(): Date | undefined {
  if (!Session.isSecondLeg()) return undefined;

  const returnLeg = Session.getCurrentLeg();
  if (returnLeg?.requestedPickupTime || returnLeg?.flight?.flightTime) {
    return undefined;
  }

  const firstLeg = Session.getLeg(0);
  const pickupDateStr = firstLeg?.requestedPickupTime || firstLeg?.flight?.flightTime;
  if (!pickupDateStr) return undefined;

  const pickupDate = parseISO(pickupDateStr);

  const daysInMonth = getDaysInMonth(pickupDate);
  if (getDate(pickupDate) > daysInMonth - 2) {
    return startOfMonth(addMonths(pickupDate, 1));
  }

  return pickupDate;
}
